import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 18 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9 16c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6Zm1-16a1 1 0 0 1 1 1v1.263a7.94 7.94 0 0 1 2.869 1.4l.297-.297a1.25 1.25 0 0 1 1.768 1.768l-.34.34A8 8 0 1 1 1 10c0-3.727 2.552-6.848 6-7.737V1a1 1 0 0 1 1-1h2ZM5.53 7.237l.035.052.098.14.948 1.339.263.371c.616.869 1.212 1.707 1.219 1.71 1.136 1.216 2.97-.62 1.757-1.755-.004-.006-.727-.52-1.526-1.088l-.372-.263c-.62-.44-1.226-.869-1.525-1.079l-.14-.098a2.691 2.691 0 0 0-.051-.035c-.46-.46-1.165.247-.706.706Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
